import React from 'react'
import {Button, Row, Col} from 'antd'
import {
    NumCompare,
    SelectGroup,
    DateCompare,
    DateItem,
    TextInput,
    CascaderOption,
    TreeSelectGroup,
    SwitchInput
} from './corAdvanceFormItemNew'
import './youkee.less'
import setLanguageText from "../utils/languageSet";

//高级搜索的表单
class AdvanceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileds: props.fileds,
            handle: props.handle,
            reset: props.reset,
            fieldHandle: props.fieldHandle,
            childRefs: [],
            labelStyle: props.labelStyle || '',
            languageSet: {}
        };
        this.gtChange = this.gtChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    gtChange(value) {
        var val = this.state.val;
        val.eq = '';
        val.gt = value;

        this.setState({val: val});
        this.state.handle(this.state.name, val);
    }

    componentDidMount() {
        setLanguageText("system", this);
    }

    resetForm() {
        var thisRefs = this.refs;
        for (var key in thisRefs) {
            if (key !== 'advform')
                thisRefs[key].reset();
        }

        thisRefs['advform'].reset();
        this.state.reset();
    }

    submitForm(e) {
        e.preventDefault();
        e.stopPropagation();
        this.state.handle(this.refs.advform);
    }

    render() {
        var self = this;
        var fileds = self.state.fileds.map((item, j) => {
            return Object.assign({}, item, self.props.fileds[j]);
        });
        var fieldHandle = this.state.fieldHandle
            , labelStyle = this.state.labelStyle
        ;

        return (
            <form className="adv-form2" ref='advform' onSubmit={this.submitForm}>
                {fileds.map(function (item, key) {
                    var item_props = {labelStyle: labelStyle, ...item, handle: fieldHandle};
                    if (item.type === 'numComp') {
                        return <NumCompare ref={'numComp' + key} {...item_props} key={key}/>
                    } else if (item.type === 'select') {
                        return <SelectGroup ref={'selectGroup' + key} {...item_props} key={key}/>
                    } else if (item.type === 'dateComp') {
                        return <DateCompare ref={'dateCompare' + key} {...item_props} key={key}/>
                    } else if (item.type === 'dateItem') {
                        return <DateItem ref={'dateItem' + key} {...item_props} key={key}/>
                    } else if (item.type === 'cascader') {
                        return <CascaderOption ref={'cascaderOption' + key} {...item_props} key={key}/>
                    } else if (item.type === 'treeSelect') {
                        return <TreeSelectGroup ref={'treeSelectGroup' + key} {...item_props} key={key}/>
                    } else if (item.type === 'SwitchInput') {
                        return <SwitchInput ref={'SwitchInput' + key} {...item_props} key={key}/>
                    } else {
                        return <TextInput ref={'textInput' + key} {...item_props} key={key}/>
                    }
                })}
                <Row style={{marginTop: '15px'}}>
                    <Col span={24} style={{textAlign: 'center'}}>
                        <Button style={{marginRight: 8}} onClick={this.resetForm}>
                            {this.state.languageSet.reset}
                        </Button>
                        <Button type="primary" htmlType="submit">{this.state.languageSet.search}</Button>
                    </Col>
                </Row>
            </form>
        );
    }
}

export default AdvanceForm



// WEBPACK FOOTER //
// ./src/components/advanceFormNew.js